import { TranslateService } from './../../shared/translate/translate.service';
import { DashboardVehicleStatus, VehicleIssue } from './../models/dashboard-vehicle-status.model';
import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'admin-dashboard-grid',
  template: require('../views/admin-dashboard-grid.component.html'),
  styles: [`
    tbody {
      display: block;
      max-height: 450px;
      overflow: auto;
    }
    thead, tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }
    thead {
      width: calc( 100% - 1em );
    }
`]
})
export class AdminDashboardGridComponent implements OnInit {
  @Input('VehicleList') vehicleList: DashboardVehicleStatus[];
  @Input('IssuePriorityList') vehicleIssuePriorityList: VehicleIssue[];
  @ViewChild('vehicleStatusGridModal') public vehicleStatusGridModal: any;
  @Output('OnExport') onExport = new EventEmitter();
  column: string = 'licenceTag';
  direction: number;
  LblNA: string;
  isDesc: boolean = false;
  constructor(private translateService: TranslateService) { }

  ngOnInit() {
    this.LblNA = this.translateService.instant('LblNA');
  }

  public show(): void {
    this.vehicleStatusGridModal.show();
  }

  public hide(): void {
    this.vehicleStatusGridModal.hide();
  }

  OnExport($event: any) {
    this.onExport.emit($event);
  }
  public TransformValue(listOfIssues: VehicleIssue[], issueType: string) {
    let issueItem = listOfIssues.find(x => x.type.toLowerCase() == issueType.toLowerCase());
    if (issueItem)
      return issueItem.issueFound;
    else
      return false;
  }

  public HandleNotAvailable(item: any) {
    if (item != null)
      return item;
    else
      return this.LblNA;
  }

  public IsIssueTypeDefined(issueType: string) {
    if (this.vehicleIssuePriorityList)
      return this.vehicleIssuePriorityList.some(x => x.type == issueType && (x.priority == "PRIORITY1" || x.priority == "PRIORITY2"));
    else
      false;
  }

  sort(property: string) {
    this.isDesc = !this.isDesc; //change the direction    
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
    this.vehicleList.sort((x: any, y: any) => this.HandleSorting(x, y));
  }

  HandleSorting(x: any, y: any) {
    if (this.column == 'stateOfChargeInPercentage'
      || this.column == 'batteryLevelInVolts') {
      if (x[this.column] < y[this.column]) {
        return -1 * this.direction;
      } else if (x[this.column] > y[this.column]) {
        return 1 * this.direction;
      } else {
        return 0;
      }
    }
    else if (this.column == 'lastLocationUpdateBefore'
      || this.column == 'lastBookingDateTimeBefore'
      || this.column == 'licenceTag'
      || this.column == 'vehicleStatus') {
      if (this.HandleNotAvailable(x[this.column]) < this.HandleNotAvailable(y[this.column])) {
        return -1 * this.direction;
      } else if (this.HandleNotAvailable(x[this.column]) > this.HandleNotAvailable(y[this.column])) {
        return 1 * this.direction;
      } else {
        return 0;
      }
    }
    else if (this.column == 'DamageReported'
      || this.column == 'CleaningRequired'
      || this.column == 'RefuelingRequired'
      || this.column == 'APKMaintananceScheduled'
      || this.column == 'OutSideGeofence'
      || this.column == 'VehicleNotReturn'
      || this.column == 'VehicleNotBooked'
      || this.column == 'LowBattery'
      || this.column == 'LowCharge'
      || this.column == 'CommunicationProblem'
      || this.column == 'VehicleSamePosition'
      || this.column == 'InvalidTagUsed') {
      if (this.TransformValue(x.listOfVehicleIssue, this.column) < this.TransformValue(y.listOfVehicleIssue, this.column)) {
        return -1 * this.direction;
      }
      if (this.TransformValue(x.listOfVehicleIssue, this.column) > this.TransformValue(y.listOfVehicleIssue, this.column)) {
        return 1 * this.direction;
      }
      else {
        return 0;
      }
    }

  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/components/admin-dashboard-grid-component.ts